<template>
  <v-list class="text-left" v-if="order" v-bind="$attrs" color="transparent">
    <v-list-item
      v-for="(item, i) in itemlist.filter(item=>item.tab && item.tab !== 'address')"
      :key="i"
      :class="{ 'pl-4': item._id.indexOf('location') > -1 }"
    >
      <v-list-item-action
        v-if="
          item._id.indexOf('location') > -1 || item.$name == 'Thuisbezorgd.nl'
        "
        class="mr-2"
      ></v-list-item-action>
      <v-list-item-action v-else class="mr-2"
        >{{ item.$quantity || item.quantity }}x</v-list-item-action
      >
      <v-list-item-content>
        <v-list-item-title v-if="item.tab == 'address'"
          >Bezorgkosten</v-list-item-title
        >
        <v-list-item-title v-else>{{ item.name }}</v-list-item-title>
        <v-list-item-subtitle v-if="item.$subname">{{
          item.$subname
        }}</v-list-item-subtitle>
        <v-list-item-subtitle v-if="item.subname">{{
          item.subname
        }}</v-list-item-subtitle>
        <v-list-item-subtitle v-else-if="!item.subname && !item.$subname && item.$include">{{
          item.$include.map((i) => i.name).join(", ")
        }}</v-list-item-subtitle>
        <v-list-item-subtitle v-if="item.$description">## {{
          item.$description
        }}</v-list-item-subtitle>
        <v-list-item-subtitle v-if="item.description">## {{
          item.description
        }}</v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action
        v-if="
          !noAmounts &&
          item._id.indexOf('location') > -1 &&
          (item.$price == 0 || item.$amount == 0)
        "
      >
        gratis
      </v-list-item-action>
      <v-list-item-action
        class="text-right"
        v-else-if="
          !noAmounts &&
          (!item.amount || item.amount == 0) &&
          (!item.$amount || item.$amount == 0)
        "
        >gratis</v-list-item-action
      >
      <v-list-item-action v-else-if="!noAmounts" class="text-right">{{
        item.$amount || item.amount | toCurrency
      }}</v-list-item-action>
    </v-list-item>
    <template v-if="order.collected">
      <v-divider></v-divider>
      <v-list-item>
        <v-list-item-action class="mr-2">##</v-list-item-action>
        <v-list-item-title>Gratis snack of drankje</v-list-item-title>
        <v-list-item-action class="mr-3"> - </v-list-item-action>
      </v-list-item>
    </template>
    <template v-if="!noAmounts">
      <v-divider></v-divider>
       <v-list-item v-if="order.deliver" class="dense">
        <v-list-item-subtitle
          class="text-right"
         
        >Bezorgkosten</v-list-item-subtitle>
        
        <v-list-item-action v-if="!order.deliver_amount>0" class="mr-3 my-0">
          gratis
        </v-list-item-action>
        <v-list-item-action class="mr-3 my-0" v-else>
          {{ order.deliver_amount | toCurrency }}
        </v-list-item-action>
      </v-list-item>
      <v-list-item v-if="order.donation_amount" class="dense">
        <v-list-item-subtitle
          class="text-right"
          v-text="order.donation"
        ></v-list-item-subtitle>
        <v-list-item-action class="mr-3 my-0">
          {{ order.donation_amount | toCurrency }}
        </v-list-item-action>
      </v-list-item>
      <v-list-item v-if="order.transaction" class="dense">
        <v-list-item-subtitle class="text-right"
          >iDEAL kosten</v-list-item-subtitle
        >
        <v-list-item-action class="mr-3 my-0">
          {{ order.transaction | toCurrency }}
        </v-list-item-action>
      </v-list-item>
      <v-list-item v-if="order.discount" class="dense">
        <v-list-item-subtitle class="text-right">Korting</v-list-item-subtitle>
        <v-list-item-action class="mr-3 my-0">
          {{ -order.discount | toCurrency }}
        </v-list-item-action>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-subtitle class="text-right" v-if="order.payment">
            <span v-if="order.payment.type == 'pin'" class="mr-2"
              >PIN Betaling bij <span v-if="order.deliver">bezorging</span
              ><span v-else>afhalen</span>
            </span>
            <span v-if="order.payment.type == 'cash'" class="mr-2"
              >Betaling bij <span v-if="order.deliver">bezorging</span
              ><span v-else>afhalen</span>
            </span>
            <!--span v-if="order.payment.type=='ideal'" class="mr-2">iDEAL</span-->
            <span v-if="order.payment.paid" class="mr-2">betaald</span>
            <b>TOTAAL</b>
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action class="text-h6">{{
          order.amount | toCurrency
        }}</v-list-item-action>
      </v-list-item>
    </template>
    <v-list-item
      v-text="order.description"
      v-if="order.description"
    ></v-list-item>
  </v-list>
</template>
<script>
/* eslint-disable */
export default {
  props: {
    value: {
      type: Object,
      default: function () {
        return null;
      },
    },
    noAmounts: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
  },
  data: () => ({}),
  computed: {
    order() {
      return this.value;
    },
    itemlist() {
      if (!this.order) return [];
      let items = this.order.items || this.order._items;
      return items
        .filter(
          (item) =>
            this.order.source != "thuisbezorgd" ||
            item._id.indexOf("location") == -1
        )
        .sort(compare);
    },
    setSource(source) {
      this.$emit("set", { source: source });
    },
    setPayment(type) {
      this.$emit("set", { type: type });
    },
    setCustomer(customer) {
      this.$emit("set", { customer: customer });
    },
    setHost(host) {
      this.$emit("set", { host: host });
    },
  },
  methods: {},
};
function compare(a, b) {
  if (a._id.indexOf("product") > -1 && a.$name != "Thuisbezorgd.nl") {
    return -1;
  } else {
    return 1;
  }
  // a must be equal to b
  return 0;
}
</script>